import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <line
                x1='4.5'
                y1='19.409'
                x2='17.909'
                y2='6'
                stroke='currentColor'
                strokeWidth='2.25'
                strokeLinecap='round'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.2949 14.7C17.2949 15.195 17.7062 15.6 18.2089 15.6C18.7117 15.6 19.123 16.005 19.123 16.5C19.123 16.995 18.7117 17.4 18.2089 17.4H14.5527V18.3C14.5527 19.794 13.3279 21 11.8105 21C10.2932 21 9.06832 19.794 9.06832 18.3V17.9297L11.398 15.6H15.4668V11.5312L17.2781 9.71994C17.2892 9.87622 17.2949 10.0362 17.2949 10.2V14.7ZM14.9491 5.68498C14.2789 5.2612 13.5146 4.99032 12.7246 4.87202V3.9C12.7246 3.405 12.3132 3 11.8105 3C11.3078 3 10.8964 3.405 10.8964 3.9V4.87202C8.49247 5.23202 6.32614 7.005 6.32614 10.2V14.3079L8.15426 12.4798V10.2C8.15426 7.797 9.98239 6.6 11.8105 6.6C12.4359 6.6 13.0613 6.74008 13.6135 7.02059L14.9491 5.68498ZM4.80864 15.8254C4.77615 15.8536 4.7457 15.8841 4.71753 15.9165L4.80864 15.8254ZM11.8105 19.2C12.3132 19.2 12.7246 18.795 12.7246 18.3V17.4H10.8964V18.3C10.8964 18.795 11.3078 19.2 11.8105 19.2Z'
            />
        </SvgIcon>
    );
});
